import React from 'react'
import './App.css'
import RoutesRender from './components/Routes/RenderRoutes'
import { Provider } from 'react-redux'
import { store, persistor } from './redux/store'
import 'bootstrap/dist/css/bootstrap.min.css'
import { AuthProvider } from './routes/AuthContext'
import { NotificationProvider } from './contexts/notificationContext'
import { PersistGate } from 'redux-persist/integration/react'

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthProvider>
          <NotificationProvider>
            <RoutesRender></RoutesRender>
          </NotificationProvider>
        </AuthProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
